export const filterdata = async (type, fileName, filterData = []) => {
    console.log(filterData, '=======');

    var searchValue = type;
    var searchValue = jQuery(':focus').val();

    if (type == 'trade') {
        searchValue = jQuery('.tradeInputData:focus').val();

    } else if (type == 'location') {
        searchValue = jQuery('.locationInputData:focus').val();
    } else if (type == 'trader') {
        searchValue = jQuery('.traderInputData:focus').val();
    }
    if (searchValue.length < 3) {
        return [];
    }
    function replace_double_word(word) {
        var ourNewString = word
            .replaceAll("ev", "ευ")
            .replaceAll("ps", "ψ")
            .replaceAll("ks", "ξ")
            // .replaceAll("av", "αυ")
            .replaceAll("th", "θ")
            // .replaceAll("κs", "θ")
            // .replaceAll("κς", "θ")
            // .replaceAll("kσ", "θ")
            // .replaceAll("εv", "ευ")
            // .replaceAll("eβ", "ευ")
            // .replaceAll("πs", "ψ")
            // .replaceAll("πσ", "ψ")
            // .replaceAll("πς", "ψ")
            // .replaceAll("κs", "ξ")
            // .replaceAll("kσ", "ξ")
            // .replaceAll("kς", "ξ")
            .replaceAll("ou", "ού")
            .replaceAll("av", "αυ");
        // .replaceAll("ώύ", "ου");
        //  .replaceAll("pi", "Π");



        return ourNewString;
    }

    function replace_exceptionWords(word) {
        var ourNewString = word
            .replaceAll("ε΄", "έ")
            .replaceAll("ε", "έ")
            .replaceAll("ί", "ι")
            .replaceAll("ι", "η")
            .replaceAll("υ", "ύ")
            .replaceAll("η", "ή")
            // .replaceAll("θ", "ό")
            .replaceAll("θ", "τή")
            .replaceAll("άύ", "άβ")
            .replaceAll("ψ", "πσ")
            .replaceAll("ξ", "κσ")
            .replaceAll("ευ", "έy")
            .replaceAll("f", "φ")
            .replaceAll("ό", "o")
            .replaceAll("ω", "ώ");
        //.replaceAll("η", "ή");


        return ourNewString;
    }

    // var language = document.getElementsByName("current_lan")[0].value;
    // console.log(language)
    //var searchValue="av";

    var searchValue = searchValue.toLowerCase();

    // const myArray = searchValue.split(" ");
    // let newString = '';
    // myArray.forEach((item) => {
    //     // const last = item.at(-1);
    //     var item_val = item;
    //     // if (last == 's') {
    //     //     var string = item.slice(0, -1);
    //     //     var item_val = string + "ς";
    //     // }
    //     newString = newString + item_val;
    // });
    // searchValue = newString;
    // searchValue = searchValue.replace(/\s/g, '');







    const map = {
        a: 'α',
        b: 'β',
        d: 'δ',
        e: 'ε',
        k: 'κ',
        n: 'η',
        r: 'π',
        t: 'τ',
        u: 'μ',
        i: 'η',
        char: 'υ',
        w: 'ω',
        x: 'χ',
        y: 'γ',
        o: 'θ',
        ο: 'ώ',

        // s: s_character,






    };

    const map2 = {
        α: 'ά',
        Α: 'Ά',
        ε: 'ε΄',
        ε: 'έ',
        // ε΄
        Ε: 'Έ',
        η: 'ή',
        Η: '΄Η',
        ι: 'ί',
        ί: 'ή',
        Ι: 'Ί',
        //  ο: 'ό', //old one
        ο: 'ώ',
        ό: 'ό',
        Ο: 'Ό',
        υ: 'ύ',
        Υ: 'Ύ',
        ω: 'ώ',
        Ω: 'Ώ',

        f: 'φ',
        i: 'ί',



    };

    const map3 = {
        a: 'α',
        α: 'ά',
        // b: 'b',
        c: 'Γ',
        d: 'δ',
        e: 'ε',
        f: 'f',
        g: 'γ',
        h: 'η',
        η: 'ή',
        i: 'ι',
        ι: 'ή',


        // j: 'j',
        k: 'κ',
        l: 'λ',
        m: 'μ',
        n: 'ν',
        ό: 'o',
        o: 'ο',
        ο: 'ώ',
        //    ου

        p: 'π',
        q: 'q',
        r: 'ρ',
        ς: 's',
        s: 'σ',

        t: 'τ',
        u: 'ύ',
        v: 'β',
        w: 'ω',
        ω: 'ώ',
        x: 'χ',
        y: 'υ',
        υ: 'ύ',
        z: 'ζ'

    };




    function replaceAllMatchedWords(word, map3) {
        var finalWord = word;

        Object.keys(map3).forEach(key => {
            finalWord = finalWord.replaceAll(key.toLowerCase(), map3[key].toLowerCase());
        });
        return finalWord.toLowerCase();

        // var ourNewString = word
        //     .replaceAll("ε΄", "έ")
        //     .replaceAll("ε", "έ")
        //    .replaceAll("ι", "η");

        // return ourNewString;
    }


    var greek_word_double_normal = replace_double_word(searchValue);
    var greek_word_double = replace_double_word(searchValue);
    var greek_word = replaceAllMatchedWords(greek_word_double, map);
    var exceptionWords = replace_exceptionWords(greek_word);



    var greek_word_double2 = replace_double_word(searchValue);
    var greek_word2 = replaceAllMatchedWords(greek_word_double2, map2);
    var exceptionWords2 = replace_exceptionWords(greek_word2);

    var greek_word_double3 = replace_double_word(searchValue);
    var greek_word3 = replaceAllMatchedWords(greek_word_double3, map3);
    var exceptionWords3 = replace_exceptionWords(greek_word3);

    var greek_word_double4 = replace_double_word(greek_word3);
    var greek_word4 = replaceAllMatchedWords(greek_word_double4, map2);
    var exceptionWords4 = replace_exceptionWords(greek_word4);


    var greek_word_double5 = replace_double_word(greek_word);
    var greek_word5 = replaceAllMatchedWords(greek_word_double5, map3);
    var exceptionWords5 = replace_exceptionWords(greek_word5);

    var inpurSearchArrayData = [
        greek_word,
        greek_word2,
        greek_word3,
        greek_word4,
        greek_word5,
        greek_word_double,
        greek_word_double2,
        greek_word_double3,
        greek_word_double4,
        greek_word_double5,
        exceptionWords,
        exceptionWords2,
        exceptionWords3,
        exceptionWords4,
        exceptionWords5
    ];

    //console.log(greek_word_double6);
    var count = 0;
    var pluginUrl = 'https://tamastoria.gr/wp-content/plugins';

    if (filterData=='') {
        var json_file = pluginUrl + '/brads-boilerplate-block-plugin/' + fileName;
        var data = await jQuery.getJSON(json_file);
      
    } else {
        var json_file = filterData;
        fileName = 'customFilterdData';
    }

   


    // var trade_file = pluginUrl + '/brads-boilerplate-block-plugin/trade_file.json';
    // var location_file = pluginUrl + '/brads-boilerplate-block-plugin/location_file.json';

    var items = [];

    // var filterData = await jQuery.getJSON(json_file, function (data) {

    if (fileName == 'professionals_file.json') {
        var post_data = data.posts;
        var mainvalue = 'post_title';
        var slug_name = 'post_name';
    }
    if (fileName == 'trade_file.json') {
        var post_data = data.data;
        var mainvalue = 'name';
        var slug_name = 'slug';
    }
    if (fileName == 'location_file.json') {
        var post_data = data.data;
        var mainvalue = 'name';
        var slug_name = 'slug';
    }
    if (fileName == 'customFilterdData') {
        var post_data = json_file.data.data;
      
        var mainvalue = 'name';
        var slug_name = 'slug';
    }
    var count = 0;
    jQuery.each(post_data, function (key, val) {
        
        if (searchValue !== null && searchValue !== '' && searchValue.length >= 3) {
            if (fileName == 'location_file.json' || fileName == 'customFilterdData') {
                var parentdata = val[0];
                var parentExist = false;
                
                jQuery.each(val, function (key, location_val) {
                    console.log(location_val, '===aaasas====');

                    var searchLabel = location_val[mainvalue].toLowerCase();
                    // searchLabel = searchLabel.replace(/\s/g, '');

                    var exceptionSearchWords = replace_exceptionWords(searchLabel);

                    var searchLabel3 = replaceAllMatchedWords(searchLabel, map);
                    var exceptionSearchWords3 = replace_exceptionWords(searchLabel3);
                    var searchLabel4 = replaceAllMatchedWords(searchLabel, map3);
                    var searchLabel2 = replaceAllMatchedWords(searchLabel4, map2);
                    var exceptionSearchWords2 = replace_exceptionWords(searchLabel2);
                    var exceptionSearchWords4 = replace_exceptionWords(searchLabel4);



                    var searcArrayData = [
                        searchLabel,
                        searchLabel2,
                        searchLabel3,
                        searchLabel4,
                        exceptionSearchWords,
                        exceptionSearchWords2,
                        exceptionSearchWords3,
                        exceptionSearchWords4
                    ];
                    var isValid = false;
                    var islocation = false;
                    searcArrayData.forEach(function (searchData, index, arr) {
                        inpurSearchArrayData.forEach(function (inputSearchdata, index, arr) {
                            // if (searchData.indexOf(inputSearchdata) > -1) {

                            const searchDataArr = searchData.split(" ");
                            var isMatch = false;
                            searchDataArr.forEach((data) => {
                                if (doesInputMatch(data, inputSearchdata)) {
                                    isMatch = true;
                                }
                            })
                            if (isMatch || doesInputMatch(searchData, inputSearchdata)) {

                                if (!isValid) {
                                    if (fileName == 'customFilterdData') {
                                        items.push({
                                            title: location_val[mainvalue],
                                            slug: location_val[slug_name],
                                            parent: location_val.parent,
                                        });
                                    } else {
                                        count++;

                                        if (!parentExist) {
                                            items.push({
                                                title: parentdata[mainvalue],
                                                slug: parentdata[slug_name],
                                                parent: parentdata.parent,
                                            });

                                        }

                                        if (location_val.parent != 0) {
                                            items.push({
                                                title: location_val[mainvalue],
                                                slug: location_val[slug_name],
                                                parent: location_val.parent,
                                            });

                                        }


                                        parentExist = true;
                                    }
                                    isValid = true;

                                }

                            }
                            //     islocation=true;
                            // }
                        });
                    });






                    if (count == 0) {
                        // jQuery('.no_result_found').show();
                    } else {
                        // jQuery('.no_result_found').hide();
                    }
                });

            } else {

                var searchLabel = val[mainvalue].toLowerCase();
                // searchLabel = searchLabel.replace(/\s/g, '');
                var exceptionSearchWords = replace_exceptionWords(searchLabel);


                var searchLabel3 = replaceAllMatchedWords(searchLabel, map);
                var exceptionSearchWords3 = replace_exceptionWords(searchLabel3);
                var searchLabel4 = replaceAllMatchedWords(searchLabel, map3);
                var searchLabel2 = replaceAllMatchedWords(searchLabel4, map2);
                var exceptionSearchWords2 = replace_exceptionWords(searchLabel2);
                var exceptionSearchWords4 = replace_exceptionWords(searchLabel4);


                var searcArrayData = [
                    searchLabel,
                    searchLabel2,
                    searchLabel3,
                    searchLabel4,
                    exceptionSearchWords,
                    exceptionSearchWords2,
                    exceptionSearchWords3,
                    exceptionSearchWords4
                ];
                var isValid = false;
                searcArrayData.forEach(function (searchData, index, arr) {
                    inpurSearchArrayData.forEach(function (inputSearchdata, index, arr) {

                        const searchDataArr = searchData.split(" ");
                        var isMatch = false;
                        searchDataArr.forEach((data) => {
                            if (doesInputMatch(data, inputSearchdata)) {
                                isMatch = true;
                            }
                        })
                        if (isMatch || doesInputMatch(searchData, inputSearchdata)) {
                            if (!isValid) {
                                count++;
                                items.push({
                                    title: val[mainvalue],
                                    slug: val[slug_name]
                                });
                                isValid = true;
                            }
                        }
                    });
                });


                if (count == 0) {
                    // jQuery('.no_result_found').show();
                } else {
                    // jQuery('.no_result_found').hide();
                }

            }

        }

    });

    // });
    // console.log(items)

    return items;
};

function doesInputMatch(reference, input) {
    // Regular expression to match a word at the beginning of the string
    var regex = new RegExp('^' + input);

    // Test if the reference starts with the specified input
    if (regex.test(reference)) {
        return true
    } else {
        return false;
    }
}